import { getCOEActiveOrNotRequestType, getCOEActiveOrNotResponseType, RetractResponseType } from './../../types/offer';
import { axiosInstance } from './index';
import {
    Base64DefaultDocumentRequestType,
    Base64RequestType,
    Base64ResponseType,
    CreateOfferResponseType,
    ExternalSignatureAccessTokenResponseType,
    GetAllRetractReasonsListResponseType,
    OfferListResponseType,
    OfferListRquestType,
    OfferRequestFeedbackType,
    OfferResponseType,
    RejectionReasonRequestType,
    RejectionReasonResponseType,
    RetractReasonRequestType,
} from '../../types/offer';
import { CompanyCandidateSearchRequest, CompanyExternalPaginatedListResponseType } from './searchCompanyCandidate';

export const offerService = {
    async create(data: FormData) {
        const { data: responseData } = await axiosInstance.post('Offer', data);
        return responseData as CreateOfferResponseType;
    },

    async getList(params: OfferListRquestType) {
        const { data: responseData } = await axiosInstance.get('Offer/GetOffers', {
            params,
        });
        return responseData as OfferListResponseType;
    },

    async get(id: string) {
        const { data: responseData } = await axiosInstance.get(`Offer/${id}`);
        return responseData as OfferResponseType;
    },

    async accept(id: string) {
        await axiosInstance.put(`Offer/${id}/Accept`);
    },

    async checkDigioDocSignStatus(data: { digioId: string }) {
        const { data: resultObject } = await axiosInstance.post(`Offer/CheckDocumentSignStatus`, data);

        return resultObject;
    },

    async reject(data: RejectionReasonRequestType) {
        await axiosInstance.put(`Offer/Reject`, data);
    },

    async retract(id: string) {
        await axiosInstance.put(`Offer/${id}/Retract`);
    },

    async delete(id: string) {
        await axiosInstance.delete(`Offer/${id}`);
    },

    async getExternalSignatureAccessToken(id: string) {
        const { data: responseData } = await axiosInstance.get(`Offer/${id}/GetExternalSignatureAccessToken`);
        return responseData as ExternalSignatureAccessTokenResponseType;
    },

    async getRejectionReason() {
        const { data: responseData } = await axiosInstance.get('RejectionReason/GetAllRejectionReasonsList');
        return responseData as RejectionReasonResponseType;
    },

    async feedback(data: OfferRequestFeedbackType) {
        await axiosInstance.post('OfferFeedback', data);
    },
    async getAllRetractReasonsList() {
        const { data: responseData } = await axiosInstance.get('RetractReason/GetAllRetractReasonsList');
        return responseData as GetAllRetractReasonsListResponseType;
    },

    async retractOffer(reasonData: RetractReasonRequestType) {
        const { data } = await axiosInstance.put('Offer/Retract', reasonData);
        return data as RetractResponseType;
    },

    // async getBase64DocString(id: string) {
    //     const { data } = await axiosInstance.get('Offer/GetFileBase64String');
    //     return data as string;
    // },

    async getBase64DocString(params: Base64RequestType) {
        const { data } = await axiosInstance.get('Offer/GetFileBase64String', {
            params,
        });
        return data as Base64ResponseType;
    },

    async getBase64DefaultDocumentString(params: Base64DefaultDocumentRequestType) {
        const { data } = await axiosInstance.get('Offer/GetDefaultPrivatePolicyDocument', {
            params,
        });
        return data as Base64ResponseType;
    },

    async getCOEActiveOrNot(params: getCOEActiveOrNotRequestType) {
        const { data } = await axiosInstance.get('Offer/GetCoeActiveOrNot', {
            params,
        });
        return data as getCOEActiveOrNotResponseType;
    },

    async getCompanyAndCandidatelList(
        params: CompanyCandidateSearchRequest
    ): Promise<CompanyExternalPaginatedListResponseType> {
        const { data } = await axiosInstance.get('Candidate/GetCompanyCandidatePaginatedList', {
            params,
        });
        return data as CompanyExternalPaginatedListResponseType;
    },
};
